import { API_PDC_URL_V2, APP_PDC_URL } from "../../config";
import axios from "axios";
import { createHttpHeaderWithAuthorization } from "../services/http-header";
import { callWithRetry } from "../services/callWithRetry";

export const statisticsConstants = {
  GET_TOTALS_COMPANY_START: "GET_TOTALS_COMPANY_START",
  GET_TOTALS_COMPANY_SUCCESS: "GET_TOTALS_COMPANY_SUCCESS",
  GET_TOTALS_COMPANY_ERROR: "GET_TOTALS_COMPANY_ERROR",

  GET_STATISTICS_START: "GET_STATISTICS_START",
  GET_STATISTICS_SUCCESS: "GET_STATISTICS_SUCCESS",
  GET_STATISTICS_ERROR: "GET_STATISTICS_ERROR",

  GET_COUNT_DOCUMENTS_START: "GET_COUNT_DOCUMENTS_START",
  GET_COUNT_DOCUMENTS_ERROR: "GET_COUNT_DOCUMENTS_ERROR",
  GET_COUNT_DOCUMENTS_SUCCESS: "GET_COUNT_DOCUMENTS_SUCCESS"
};

export function getTotalsCompany() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;
    const clientIdSelected = main.clientIdSelected;
    const accountantIdSelected = main.accountantIdSelected;

    let today = new Date();
    let currentYear = today.getFullYear();
    let lastYear = currentYear - 1;
    let request = {
      method: "get",
      url:
        APP_PDC_URL +
        "/statistics/companyTotals?company=" +
        clientIdSelected +
        "&year=" +
        currentYear +
        "," +
        lastYear +
        "&accountantId=" +
        accountantIdSelected,
      headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
    };

    return new Promise(function(resolve, reject) {
      dispatch({
        type: statisticsConstants.GET_TOTALS_COMPANY_START
      });
      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: statisticsConstants.GET_TOTALS_COMPANY_SUCCESS,
              payload: { companyId: clientIdSelected, totals: result.data }
            });
          } else {
            dispatch({
              type: statisticsConstants.GET_TOTALS_COMPANY_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch((response) => {
          dispatch({
            type: statisticsConstants.GET_TOTALS_COMPANY_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function findStatistics(
  auth, clientIdSelected, accountantIdSelected
) {
  let today = new Date();
  let currentYear = today.getFullYear();
  let lastYear = currentYear - 1;
  let request = {
    method: "get",
    url: API_PDC_URL_V2 + "/statistics?company=" + clientIdSelected + "&year=" + currentYear + "," + lastYear + "&accountantId=" + accountantIdSelected,
    headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
  };

  return (dispatch) => {
    return new Promise(function(resolve, reject) {
      dispatch({
        type: statisticsConstants.GET_STATISTICS_START
      });
      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: statisticsConstants.GET_STATISTICS_SUCCESS,
              payload: {
                companyId: clientIdSelected,
                accountantId: accountantIdSelected,
                stats: result.data
              }
            });
          } else {
            dispatch({
              type: statisticsConstants.GET_STATISTICS_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch((response) => {
          dispatch({
            type: statisticsConstants.GET_STATISTICS_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function getCountDocumentsByCategory(customerId, accountantId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    let url = `${APP_PDC_URL}/v2/documents/count?accountantId=${accountantId}&itemId=${customerId}`;
    let request = {
      method: "GET",
      url: `${url}`,
      headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
    };
    return new Promise(function(resolve, reject) {
      dispatch({
        type: statisticsConstants.GET_COUNT_DOCUMENTS_START
      });
      axios(request)
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: statisticsConstants.GET_COUNT_DOCUMENTS_SUCCESS,
              payload: { totals: result.data }
            });
          } else {
            dispatch({
              type: statisticsConstants.GET_COUNT_DOCUMENTS_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch((response) => {
          dispatch({
            type: statisticsConstants.GET_COUNT_DOCUMENTS_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}
